import { parseUnits } from "ethers";
import { ADDRS } from "../../Contracts/V3/addresses";

export function safeParseUnits(v, decimals) {
  try {
    const s = (v ?? "").toString().trim().replace(/,/g, "");
    if (!s) return 0n;
    return parseUnits(s, Number(decimals));
  } catch {
    return null;
  }
}

const WETHW_LC = (ADDRS?.WETHW || "").toLowerCase();
export const isWethw = (a) => a && a.toLowerCase() === WETHW_LC;
